import { IAppState } from '../../app.types';

import * as types from './subscription-access.types';

export const subscriptionAccessSelectors: types.ISubscriptionAccessSelectors = {
  selectSubscriptionAccess: (state: IAppState) => state.resource.subscriptionAccess,
  selectAiNotesEnabled: (state: IAppState) => state.resource.subscriptionAccess?.aiNotesEnabled ?? false,
  selectMcpEnabled: (state: IAppState) => state.resource.subscriptionAccess?.mcpEnabled ?? false,
};
